/* eslint-disable quote-props */
module.exports = {
  // Images
  '89504e47': 'image/png',
  'ffd8ff': 'image/jpeg',
  '0000000C6A5020200D0A870A': 'image/jp2', // JPEG 2000
  '47494638': 'image/gif',
  '89504e470d0a1a0a': 'image/png',
  '424d': 'image/bmp', // BMP
  '49492a00': 'image/tiff', // TIFF (little endian)
  '4d4d002a': 'image/tiff', // TIFF (big endian)
  '52494646........57454250': 'image/webp', // WebP
  '6674797068656963667479706d': 'image/heic', // HEIC
  '69636e73': 'image/x-icns', // Apple Icon Image

  // Audio
  '494433': 'audio/mpeg', // MP3
  'fff1': 'audio/aac', // AAC
  'fff9': 'audio/aac', // AAC
  '5249464657 41 56 45': 'audio/wav', // WAV
  '2e736e64': 'audio/basic', // AU
  '4d546864': 'audio/midi', // MIDI

  // Video
  '66747970': 'video/mp4', // MP4
  '000001ba': 'video/mpeg', // MPEG
  '000001b3': 'video/mpeg', // MPEG
  '5249464641564920': 'video/avi', // AVI
  '1a45dfa3': 'video/webm', // WebM
  '00000018': 'video/mp4', // MP4

  // Archives
  '504b0304': 'application/zip', // ZIP
  '504b0506': 'application/zip', // ZIP (empty)
  '504b0708': 'application/zip', // ZIP (spanned)
  '1f8b08': 'application/gzip', // GZIP
  '377abcaf': 'application/x-7z-compressed', // 7-Zip
  '425a68': 'application/x-bzip2', // BZip2
  '52617221': 'application/x-rar-compressed', // RAR
  '7f454c46': 'application/x-executable', // ELF

  // Microsoft Office (old format)
  'd0cf11e0': 'application/msword', // DOC (old)
  // 'd0cf11e0': 'application/vnd.ms-excel', // XLS (old)
  // 'd0cf11e0': 'application/vnd.ms-powerpoint', // PPT (old)

  // Microsoft Office (Open XML format)
  // '504b0304': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
  // '504b0304': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
  // '504b0304': 'application/vnd.openxmlformats-officedocument.presentationml.presentation', // PPTX

  // Documents
  '25504446': 'application/pdf', // PDF
  '7b5c7274': 'application/rtf', // RTF

  // Plain text and markup
  'efbbbf': 'text/plain', // UTF-8 with BOM
  'fffe': 'text/plain', // UTF-16LE
  'feff': 'text/plain', // UTF-16BE
  '3c3f786d': 'text/xml', // XML
}
